import { __assign } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "note-container" };
var _hoisted_2 = { class: "console-note-options-aria" };
var _hoisted_3 = { class: "single-note-container" };
var _hoisted_4 = { class: "note-footer" };
var _hoisted_5 = ["title"];
var _hoisted_6 = { class: "note-time" };
var _hoisted_7 = ["onClick", "title"];
var _hoisted_8 = { class: "note-link-item-description" };
import { onBeforeUnmount, onMounted, ref } from "vue";
import { MdPreview, config } from "md-editor-v3";
import "md-editor-v3/lib/style.css"; // MD 引入样式，否则主题无效!!!!!!!>sp
import { useStore } from "@/store";
import { processMdContent } from "@/utils/phrase";
import tools from "@/utils/tools";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SingleNote',
    props: {
        propNote: {
            type: Object,
            required: true,
        },
        propIndex: {
            type: Number,
            required: true,
        },
        onDelete: {
            type: Function,
            required: true,
        },
        macy: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var store = useStore();
        var attribute = __props;
        var noteItem = ref(attribute.propNote);
        var noteIndex = ref(attribute.propIndex);
        var noteContentContainerRef = ref(null);
        var noteResizeObserver = null;
        var noteBaseUrl = "http://".concat(window.location.host, "/note/").concat(noteItem.value.id);
        noteItem.value.content = processMdContent(noteItem.value.content, {
            RESOURCE_BASE: noteBaseUrl,
        });
        if (Array.isArray(noteItem.value.link)) {
            noteItem.value.link = noteItem.value.link.map(function (linkItem) { return (__assign(__assign({}, linkItem), { href: processMdContent(linkItem.href, {
                    RESOURCE_BASE: noteBaseUrl,
                }) })); });
        }
        function switchDarkTheme() {
            return store.isDarkTheme ? "dark" : "light";
        }
        function modifyNote() {
            api.request
                .quickPost("/createmodifynotedraft", {
                noteID: noteItem.value.id,
            })
                .then(function (resp) {
                window.$notifySuccess("创建修改随记草稿成功", "记忆修正？");
                tools.jumptoLocal("/note-release");
            })
                .catch(function (err) {
                window.$notifyError("创建修改随记草稿失败", err.response.msg);
                console.error(err);
            });
        }
        function deleteNote() {
            api.request
                .quickPost("/deletenote", {
                noteID: noteItem.value.id,
            })
                .then(function (resp) {
                window.$notifySuccess("删除随记成功", "不会再回来的回忆");
                attribute.onDelete(noteItem.value.id);
            })
                .catch(function (err) {
                window.$notifyError("删除随记失败", err.response.msg);
            });
        }
        config({
            markdownItPlugins: function (plugins) {
                return plugins.filter(function (p) { return p.type !== "xss"; });
            },
        });
        var mdHeadingId = function (text, _level, index) {
            return "heading-".concat(text, "-").concat(index);
        };
        onMounted(function () {
            var els = document.querySelectorAll(".note-footer");
            els.forEach(function (el) {
                el.addEventListener("wheel", function (e) {
                    if (e.deltaY !== 0) {
                        e.preventDefault();
                        el.scrollLeft += e.deltaY;
                    }
                }, { passive: false });
            });
            noteResizeObserver = new ResizeObserver(function () {
                if (attribute.macy) {
                    attribute.macy.recalculate(true);
                }
                else {
                    console.error("ResizeObserver error: macy is null");
                }
            });
            if (noteContentContainerRef.value) {
                noteResizeObserver.observe(noteContentContainerRef.value);
            }
        });
        onBeforeUnmount(function () {
            if (noteResizeObserver) {
                noteResizeObserver.disconnect();
                noteResizeObserver = null;
            }
        });
        return function (_ctx, _cache) {
            var _component_CustomSVG = _resolveComponent("CustomSVG");
            var _component_n_icon = _resolveComponent("n-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "modify-note note-option",
                        title: "修改随记",
                        onClick: modifyNote
                    }, [
                        _createVNode(_component_n_icon, {
                            size: "1rem",
                            class: "note-option-icon"
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_CustomSVG, { icon: "Edit" })
                            ]; }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", {
                        class: "delete-note note-option",
                        title: "删除随记",
                        onClick: deleteNote
                    }, [
                        _createVNode(_component_n_icon, {
                            size: "1rem",
                            class: "note-option-icon"
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_CustomSVG, { icon: "Delete24Filled" })
                            ]; }),
                            _: 1
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                        class: "note-content-container",
                        ref_key: "noteContentContainerRef",
                        ref: noteContentContainerRef
                    }, [
                        _createVNode(_unref(MdPreview), {
                            theme: switchDarkTheme(),
                            id: "noteContent-".concat(noteIndex.value),
                            class: "note-content-preview",
                            editorId: "note-".concat(noteIndex.value),
                            modelValue: noteItem.value.content,
                            mdHeadingId: mdHeadingId
                        }, null, 8, ["theme", "id", "editorId", "modelValue"])
                    ], 512),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "note-devide-line" }, null, -1)),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "note-time-container note-footer-item",
                            title: "\u521B\u5EFA\u65F6\u95F4\uFF1A".concat(_unref(tools).formatDatetime(noteItem.value.time))
                        }, [
                            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "solitude fa-solid fa-calendar-days" }, null, -1)),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(tools).countHowManyTimesAgo(noteItem.value.time)), 1)
                        ], 8, _hoisted_5),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noteItem.value.link, function (linkItem, linkIndex) {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "note-link-container note-footer-item",
                                onClick: function ($event) { return (_unref(tools).jumpto(linkItem.href)); },
                                title: "\u524D\u5F80 ".concat(linkItem.href)
                            }, [
                                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa-solid fa-link" }, null, -1)),
                                _createElementVNode("div", _hoisted_8, _toDisplayString(linkItem.describe || "\u94FE\u63A5".concat(linkIndex + 1)), 1)
                            ], 8, _hoisted_7));
                        }), 256))
                    ])
                ])
            ]));
        };
    }
});
